import { Button, Tooltip } from 'antd';
import { useEffect, useState } from 'react';

interface Props {
  editor: any;
  commandName: string;
  commandValue?: string;
  icon: React.ReactNode;
  tooltip: string;
  isToggleButton?: boolean;
}

export const ToolbarButton: React.FC<Props> = (props) => {
  const {
    editor,
    commandName,
    commandValue,
    icon,
    tooltip,
    isToggleButton = false,
  } = props;

  const command = editor ? editor.commands.get(commandName) : null;
  const [isOn, setIsOn] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);

  useEffect(() => {
    if (!command) return;

    function handleValueChange() {
      if (typeof command.value === 'boolean') {
        setIsOn(!!command.value);
      } else {
        setIsOn(commandValue === command.value);
      }
    }

    function handleIsEnabledChange() {
      setIsEnabled(command.isEnabled);
    }

    command.on('change:value', handleValueChange);
    command.on('change:isEnabled', handleIsEnabledChange);

    handleValueChange();
    handleIsEnabledChange();

    return function cleanup() {
      command.off('change:value', handleValueChange);
      command.off('change:isEnabled', handleIsEnabledChange);
    };
  }, [command, commandValue]);

  return (
    <Tooltip title={tooltip}>
      <Button
        type={'text'}
        className={
          isOn && isToggleButton ? 'tw-bg-[#bdbdbd] hover:!tw-bg-[#bdbdbd]' : ''
        }
        icon={icon}
        disabled={!isEnabled}
        onClick={() => {
          if (commandValue) {
            editor.execute(commandName, { value: commandValue });
          } else {
            editor.execute(commandName);
          }
          editor.editing.view.focus();
        }}
      />
    </Tooltip>
  );
};
